import { render, staticRenderFns } from "./HomeActivate.vue?vue&type=template&id=2af03405"
import script from "./HomeActivate.vue?vue&type=script&lang=js"
export * from "./HomeActivate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports